import { resolve } from "../../di/di";
import { diConstants } from "../../di/di.constants";
import WsClient from "./ws-client";

export function injectWebSocketClient() {
  return resolve<WsClient>(diConstants.WS)();
}
